import { Component, Input } from '@angular/core';
import { SkillsSubNavigationLink } from '@freelancer/datastore/collections';
import { LinkColor } from '@freelancer/ui/link';

@Component({
  selector: 'app-navigation-secondary-skills-nav-link',
  template: `
    <fl-link
      flTrackingLabel="SkillsNavLink"
      [color]="LinkColor.DARK"
      [link]="skillsNavLink.url"
    >
      {{ skillsNavLink.text }}
    </fl-link>
  `,
  styleUrls: ['./navigation-secondary-skills-nav-link.component.scss'],
})
export class NavigationSecondarySkillsNavLinkComponent {
  LinkColor = LinkColor;

  @Input() skillsNavLink: SkillsSubNavigationLink;
}
